import moment from 'moment';

export default {
    state: {
        practice: null,
        aspitUser: null,
        upgradeDate: null,
        currentStep: null,
        termsAccepted: false,
        maxExtensionInDays: null,
        suggestedUpgradeDate: null,
        currentRouteName: 'landing',
    },

    getters: {
        brand (state) {
            return state.aspitUser ? state.aspitUser.brand : '';
        },

        defaultSteps () {
            return [
                {
                    id: 1,
                    title: `${this.trans('apps.bank_id.login_with')} ${this.trans('subscription.app_title.bank-id')}`,
                    stepTitle: this.trans('apps.bank_id.name'),
                    icon: 'fa fa-1',
                    routeName: `bankIdLogin`,
                },
                {
                    id: 2,
                    title: this.trans('aspit.onboarding.steps.practiceInfoTitle'),
                    stepTitle: this.trans('aspit.onboarding.steps.practiceInfo'),
                    icon: 'fa fa-2',
                    routeName: `practiceInfo`
                },
                {
                    id: 3,
                    title: this.trans('aspit.onboarding.steps.upgradeDetailsTitle'),
                    stepTitle: this.trans('aspit.onboarding.steps.upgradeDetails'),
                    icon: 'fa fa-3',
                    routeName: `planUpgrade`
                },
                {
                    id: 4,
                    title: `${this.trans('events.receipt')}`,
                    stepTitle: this.trans('events.receipt'),
                    icon: 'fa fa-4',
                    routeName: `confirmation`
                }
            ]
        },

        steps (state, getters) {
            return getters.defaultSteps.map(step => {
                return {
                    ...step,
                    active: getters.currentStepNumber === step.id,
                    completed: getters.currentStepNumber > step.id,
                }
            });
        },

        currentStepItem (state, getters) {
            return getters.defaultSteps.find(step => step.routeName === state.currentRouteName);
        },

        currentStepNumber (state, getters) {
            return getters.currentStepItem.id;
        },

        currentStepTitle (state, getters) {
            return getters.currentStepItem.title;
        },

        upgradeDateFormatted (state) {
            return state.upgradeDate
                ? moment(state.upgradeDate, 'DD-MM-YYYY HH:mm:ss').locale(moment_locale).format('DD MMMM YYYY - HH:mm')
                : '';
        },

        userName (state) {
            return state.aspitUser ? state.aspitUser.name : '';
        },

        supportEmail (state) {
            return state.aspitUser ? state.aspitUser.supportEmail : '';
        },

        supportPhone (state) {
            return state.aspitUser ? state.aspitUser.supportPhone : {};
        },

        suggestedUpgradeDateFormatted (state) {
            return state.suggestedUpgradeDate
                ? moment(state.suggestedUpgradeDate, 'DD-MM-YYYY').locale(moment_locale).format('D MMMM YYYY')
                : '';
        },

        logoUrl (state, getters) {
            return `${baseurl}/${Config.get(`brands.${getters.brand}.logo_png`)}`
        }
    },

    mutations: {
        SET_CURRENT_ROUTE_NAME (state, routeName) {
            state.currentRouteName = routeName
        },

        SET_MIGRATION_DATE (state, date) {
            state.upgradeDate = date
        },

        SET_ASPIT_USER (state, user) {
            state.aspitUser = user
        },

        SET_PRACTICE (state, practice) {
            state.practice = practice
        },

        SET_TERMS_ACCEPTED (state, accepted) {
            state.termsAccepted = accepted
        }
    },

    actions: {
        setCurrentRouteName ({ commit }, payload) {
            commit('SET_CURRENT_ROUTE_NAME', payload)
        },

        setUpgradeDate ({ commit }, payload) {
            commit('SET_MIGRATION_DATE', payload)
        },

        setAspitUser ({ commit }, payload) {
            commit('SET_ASPIT_USER', payload)
        },

        setPractice({ commit }, payload) {
            commit('SET_PRACTICE', payload)
        },

        setTermsAccepted({ commit }, payload) {
            commit('SET_TERMS_ACCEPTED', payload)
        }
    }

}
